<template>
  <div class="min-h-screen flex flex-col md:items-center md:justify-center py-8 md:bg-gray-50">
    <div class="w-full md:max-w-xl md:rounded-2xl md:shadow-lg md:bg-white md:p-8 md:max-h-90vh md:flex md:flex-col md:overflow-hidden">
      <CuWizard :buttons="buttons">
    <template #header>
      <div class="flex items-center justify-between px-4 pt-6 pb-2">
<button @click="handleBack" class="text-2xl text-gray-500">
  <i class="bx bx-chevron-left"></i>
</button>
        <div class="font-semibold text-base">Candidatura</div>
        <button class="text-2xl text-gray-500">
          <i class="bx bx-dots-horizontal-rounded"></i>
        </button>
      </div>
      <WizardSteps :current="step" :total="totalSteps" />
    </template>
<EtaScenicaSheet
  :show="showEtaScenicaSheet"
  :min="form.eta ? Math.max(0, Number(form.eta) - 10) : 0"
  :max="form.eta ? Number(form.eta) + 10 : 100"
  :value="Array.isArray(form.eta_scenica) && form.eta_scenica.length === 2 ? form.eta_scenica : [form.eta ? Math.max(0, Number(form.eta) - 5) : 0, form.eta ? Number(form.eta) + 5 : 0]"
  @close="showEtaScenicaSheet = false"
  @confirm="handleEtaScenicaConfirm"
/>
<ExitConfirmationSheet
  :show="showExitConfirmationSheet"
  @close="showExitConfirmationSheet = false"
  @confirm="handleExitConfirm"
/>
    <div v-if="step === 1" class="flex flex-col flex-1 px-4 overflow-y-auto">
      <h2 class="text-2xl font-bold text-center mb-2 mt-2">Completa il tuo profilo</h2>
      <p class="text-gray-500 text-center mb-6">
        Non temere, non dovrai più inserire nulla per la prossima candidatura!
      </p>
              <!-- nationality-->
      <div class="mb-4 relative">


          <div class="text-sm mb-2 text-left">
            Sono di <span class="text-orange-500 font-semibold">nazionalità</span>:
          </div>
          <CuRadioGroup
            v-model="form.nationality"
            :options="nationalityOptions"
            inline
          />
        </div>

     
        
      <form @submit.prevent="nextStep" class="flex flex-col gap-0 pb-4">
        <CuInput
          label="Nome"
          v-model="form.name"
          type="text"
          placeholder="Mario"
          :danger="showValidation && !validators.name(form.name)"
        />
        <CuInput
          label="Cognome"
          v-model="form.surname"
          type="text"
          placeholder="Rossi"
          :danger="showValidation && !validators.name(form.surname)"
        />
        
        <CuInput
          :label="form.nationality === 'Italia' ? 'Codice Fiscale' : 'AVS'"
          v-model="form.codice_fiscale"
          type="text"
          :placeholder="form.nationality === 'Italia' ? 'RSSMRA80A01H501U' : '756.XXX.XXX.XXX'"
          :danger="showValidation && !validators.codiceFiscale(form.codice_fiscale)"
        />
        <div class="mb-4 relative">
          <CuInput
            :value="form.birthdate"
            type="text"
            label="Data di nascita"
            placeholder="gg/mm/aaaa"
            :danger="showValidation && !validators.birthdate(form.birthdate)"
            readonly
            @click.native="openDatePicker"
          >
            <template #right>
              <i class="bx bx-calendar text-2xl text-gray-400 cursor-pointer" @click.stop="openDatePicker"></i>
            </template>
          </CuInput>

          <teleport to="body">
            <div
              v-if="showDatePicker"
              ref="datePickerContainer"
              class="fixed "
              style="z-index: 9999;"
              :style="datePickerStyle"
            >
              <vc-date-picker
                v-model="tempBirthdate"
                color="orange"
                :max-date="new Date()"
                :min-date="new Date(1900, 0, 1)"
                mode="single"
                is-inline
                @change="showDatePicker = false"
              />
            </div>
          </teleport>
        </div>
        <CuPhoneInput
          :value="form.phone"
          label="Telefono"
          placeholder="+39 123 456 7890"
          :danger="showValidation && !validators.phone(form.phone)"
          :disabled="phonePrefilled"
        />
        <CuInput
          v-model="form.email"
          type="email"
          label="Email"
          placeholder="utente@email.it"
          :danger="showValidation && !validators.email(form.email)"
        />
        <CuInput
          v-model="form.password"
          :type="showPassword ? 'text' : 'password'"
          placeholder="**********"
          label="Password"
          class="mb-0"
          :danger="showValidation && !validators.password(form.password)"
        >
          <template #right>
            <button type="button" class="text-gray-400" @click="showPassword = !showPassword" tabindex="-1">
              <i class="bx text-2xl" :class="showPassword ? ' bx-show' : ' bx-hide'"></i>
            </button>
          </template>
        </CuInput>
        <div v-if="showValidation && !validators.password(form.password)" class="text-xs text-red-500 mt-0 mb-3 text-left">
          La password deve contenere:
          <ul class="list-disc pl-5">
            <li>Almeno 8 caratteri</li>
            <li>Almeno un numero</li>
            <li>Almeno un carattere speciale (!@#$£%^&*(),.?":{}|)</li>
            <li>Nessuno spazio</li>
          </ul>
        </div>
        
        <!-- Parent information section for under 18 users -->
        <div v-if="isUnder18" class="mt-6 flex flex-col">
          <div class="border-t border-gray-200 pt-4 mb-4">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">ANAGRAFICA GENITORE</h3>
          </div>
          
          <CuInput
            label="Nome Genitore"
            v-model="form.nome_genitore"
            type="text"
            placeholder="Mario"
            :danger="showValidation && !validators.parentRequired(form.nome_genitore)"
          />
          <CuInput
            label="Cognome Genitore"
            v-model="form.cognome_genitore"
            type="text"
            placeholder="Rossi"
            :danger="showValidation && !validators.parentRequired(form.cognome_genitore)"
          />
          
          <div class="mb-3">
          <CuInput
            :label="form.nationality === 'Italia' ? 'Codice Fiscale Genitore' : 'AVS Genitore'"
            v-model="form.codice_fiscale_genitore"
            type="text"
            :placeholder="form.nationality === 'Italia' ? 'RSSMRA80A01H501U' : '756.XXX.XXX.XXX'"
            :danger="showValidation && !validators.parentCodiceFiscale(form.codice_fiscale_genitore)"
          />
          </div>
          
          <CuPhoneInput
            :value="form.phone_genitore"
            label="Telefono Genitore"
            placeholder="+39 123 456 7890"
            :danger="showValidation && !validators.parentPhone(form.phone_genitore)"
            @input="form.phone_genitore = $event"
          />
          
          <CuInput
            label="Documento Genitore"
            v-model="form.documento_genitore"
            type="text"
            placeholder="Carta d'identità, Passaporto, etc."
            :danger="showValidation && !validators.parentRequired(form.documento_genitore)"
          />
          
          <div class="mb-0 relative">
            <CuInput
              :value="form.data_nascita_genitore"
              type="text"
              label="Data di nascita Genitore"
              placeholder="gg/mm/aaaa"
              :danger="showValidation && !validators.parentBirthdate(form.data_nascita_genitore)"
              readonly
              @click.native="openParentDatePicker"
            >
              <template #right>
                <i class="bx bx-calendar text-2xl text-gray-400 cursor-pointer" @click.stop="openParentDatePicker"></i>
              </template>
            </CuInput>

            <teleport to="body">
              <div
                v-if="showParentDatePicker"
                ref="parentDatePickerContainer"
                class="fixed "
                style="z-index: 9999;"
                :style="parentDatePickerStyle"
              >
                <vc-date-picker
                  v-model="tempParentBirthdate"
                  color="orange"
                  :max-date="new Date()"
                  :min-date="new Date(1900, 0, 1)"
                  mode="single"
                  is-inline
                  @change="showParentDatePicker = false"
                />
              </div>
            </teleport>
          </div>
          <div v-if="showValidation && form.data_nascita_genitore && !validators.parentBirthdate(form.data_nascita_genitore)" class="text-red-500 text-xs mt-1">
            Il genitore deve avere almeno 18 anni
          </div>
        </div>
        
        <div class="flex items-start gap-2 mt-2 mb-3 pl-1 align-items-center">
          <input
            id="acceptTos"
            type="checkbox"
            v-model="form.acceptTos"
            :class="[showValidation && !form.acceptTos ? 'ring-2 ring-red-400' : '']"
          />
          <label for="acceptTos" class="text-xs text-gray-600 select-none">
            Accetto i&nbsp;
            <a href="https://www.castingup.it/termini-e-condizioni-castingup.pdf" target="_blank" rel="noopener" class="underline hover:text-gray-800">Termini di servizio</a>
            &nbsp;e&nbsp;
            <a href="https://castingup.it/informativa-privacy-castingup.pdf" target="_blank" rel="noopener" class="underline hover:text-gray-800">Privacy Policy</a>
            .
          </label>
        </div>
        <div v-if="showValidation && !form.acceptTos" class="text-red-500 text-xs mt-1">Devi accettare i termini e la privacy policy</div>
      </form>
    </div>
    <div v-if="step === 2" class="flex flex-col flex-1 px-4 overflow-y-auto">
      <h2 class="text-2xl font-bold text-center mb-2 mt-2">Aspetto fisico</h2>
      <p class="text-gray-500 text-center mb-6">
        Non temere, non dovrai più inserire nulla per la prossima candidatura!
      </p>
      <form @submit.prevent="nextStep" class="flex flex-col gap-4 pb-4">
         <div class="flex gap-4">
          <div class="flex-1">
            <CuInput
              label="Età"
              v-model="form.eta"
              type="tel"
              inputmode="numeric"
              placeholder=""
              :danger="showValidation && !validators.eta(form.eta)"
            />
          </div>
          <div class="flex-1">
            <CuInput
              label="Età scenica"
              :value="etaScenicaDisplay"
              readonly
              placeholder="Seleziona intervallo"
              @click.native="showEtaScenicaSheet = true"
              :danger="showValidation && !validators.eta_scenica(form.eta_scenica)"
            >
              <template #right>
                <i class="bx bx-slider text-2xl text-gray-400 cursor-pointer" @click.stop="showEtaScenicaSheet = true"></i>
              </template>
            </CuInput>
          </div>
        </div>
        <div class="flex gap-4">
          <div class="flex-1">
            <CuSelect
              label="Genere"
              v-model="form.gender"
              :options="genderOptions"
              placeholder="Seleziona"
              :danger="showValidation && !validators.required(form.gender)"
            />
          </div>
          <div class="flex-1">
            <CuSelect
              label="Occhi"
              v-model="form.eyes"
              :options="eyesOptions"
              placeholder="Seleziona"
              :danger="showValidation && !validators.required(form.eyes)"
            />
          </div>
          
        </div>
        <div class="flex gap-4">
          <div class="flex-1">
            <CuInput
              label="Altezza"
              v-model="form.height"
              type="tel"
              inputmode="numeric"
              placeholder=""
              :danger="showValidation && !validators.height(form.height)"
            >
              <template #right>
                <span class="text-gray-400 text-base mr-2">cm</span>
              </template>
            </CuInput>
          </div>
          <div class="flex-1">
            <CuSelect
              label="Etnia"
              v-model="form.ethnicity"
              :options="ethnicityOptions"
              placeholder="Seleziona"
              :danger="showValidation && !validators.required(form.ethnicity)"
            />
          </div>
        </div>
        <div class="flex gap-4">
          <div class="flex-1">
            <CuInput
              label="Peso"
              v-model="form.weight"
              type="tel"
              inputmode="numeric"
              placeholder=""
              :danger="showValidation && !validators.weight(form.weight)"
            >
              <template #right>
                <span class="text-gray-400 text-base mr-2">Kg</span>
              </template>
            </CuInput>
          </div>
          <div class="flex-1">
            <CuSelect
              label="Corporatura"
              v-model="form.bodyType"
              :options="bodyTypeOptions"
              placeholder="Seleziona"
              :danger="showValidation && !validators.required(form.bodyType)"
            />
          </div>
        </div>
        <div class="flex gap-4">
          <div class="flex-1">
            <CuSelect
              label="Taglia"
              v-model="form.size"
              :options="sizeOptions"
              placeholder="Seleziona"
              :danger="showValidation && !validators.required(form.size)"
            />
          </div>
          <div class="flex-1">
            <CuInput
              label="Numero Scarpe"
              v-model="form.shoeSize"
              type="tel"
              inputmode="numeric"
              placeholder=""
              :danger="showValidation && !validators.shoeSize(form.shoeSize)"
            />
          </div>
        </div>
       
        
      </form>
    </div>
    <div v-if="step === 3" class="flex flex-col flex-1 px-4 overflow-y-auto">
      <h2 class="text-2xl font-bold text-center mb-2 mt-2">Capelli</h2>
      <p class="text-gray-500 text-center mb-6">
        Non temere, non dovrai più inserire nulla per la prossima candidatura!
      </p>
      <form @submit.prevent="nextStep" class="flex flex-col gap-4 pb-4">
        <div class="flex gap-4">
          <div class="flex-1">
            <CuSelect
              label="Colore"
              v-model="form.hairColor"
              :options="hairColorOptions"
              placeholder="Seleziona"
              :searchable="false"
              :danger="showValidation && !validators.required(form.hairColor)"
            />
          </div>
          <div class="flex-1">
            <CuSelect
              label="Tipologia"
              v-model="form.hairType"
              :options="hairTypeOptions"
              placeholder="Seleziona"
              :searchable="false"
              :danger="showValidation && !validators.required(form.hairType)"
            />
          </div>
        </div>
        <div>
          <div class="text-sm mb-2 text-left">
            Sei disponibile al <span class="font-semibold">taglio</span> dei capelli?
          </div>
          <CuRadioGroup
            v-model="form.hairCut"
            :options="hairCutOptions"
            inline
          />
        </div>
        <div class="mb-4">
          <div class="text-sm mb-2 text-left">
            Sei disponibile alla <span class="font-semibold">colorazione</span> dei capelli?
          </div>
          <CuRadioGroup
            v-model="form.hairColoring"
            :options="hairColoringOptions"
            inline
          />
        </div>
      </form>
    </div>
    <div v-if="step === 4" class="flex flex-col flex-1 px-4 overflow-y-auto">
      <h2 class="text-2xl font-bold text-center mb-2 mt-2">Ultime informazioni</h2>
      <p class="text-gray-500 text-center mb-6">
        Non temere, non dovrai più inserire nulla per la prossima candidatura!
      </p>
      <form @submit.prevent="saveProfile" class="flex flex-col gap-4 pb-4">
        <div class="flex flex-col items-center mb-4">
          <div class="relative">
<template v-if="form.avatar">
  <img
    :src="form.avatar"
    alt="Avatar"
    class="w-24 h-24 rounded-full object-cover border-2 border-gray-300"
  />
</template>
<template v-else>
  <div class="w-24 h-24 flex items-center justify-center rounded-full bg-primary opacity-60 border-2 border-gray-300">
    <i class="bx bx-user text-white text-5xl"></i>
  </div>
</template>
            <button
              type="button"
              class="absolute bottom-0 right-0 bg-primary text-white rounded-full p-2 shadow w-8 h-8 flex items-center justify-center"
              @click.prevent="triggerAvatarInput"
              title="Scegli foto"
            >
              <i class="bx bx-camera"></i>
            </button>
            <input
              ref="avatarInput"
              type="file"
              accept="image/*"
              class="hidden"
              @change="handleAvatarChange"
            />
          </div>
          <div v-if="showValidation && !form.avatar" class="text-red-500 text-xs mt-2">La foto profilo è obbligatoria</div>
        </div>
        <CuSelect
          label="Professione"
          v-model="form.profession"
          :options="professionOptions"
          placeholder="Seleziona"
          :danger="showValidation && !validators.required(form.profession)"
          :multiple="true"
        />

        <h4><b>Attualmente</b> mi trovo in:</h4>

         
          <CuRadioGroup
            v-model="form.country"
            :options="countryOptions"
            inline
          />
        
        <template v-if="form.country === 'Italia'">
          <CuSelect
            label="Regione"
            v-model="form.region"
            :options="regionOptions"
            placeholder="Seleziona"
            :danger="showValidation && !validators.required(form.region)"
            @change="form.province = ''; form.comune = ''"
          />
          <CuSelect
            label="Provincia"
            v-model="form.province"
            :options="provinceOptions"
            placeholder="Seleziona"
            :danger="showValidation && !validators.required(form.province)"
            @change="form.comune = ''"
          />
          <CuSelect
            label="Comune"
            v-model="form.comune"
            :options="comuneOptions"
            placeholder="Seleziona"
            :danger="showValidation && !validators.required(form.comune)"
          />
        </template>
        <template v-else-if="form.country === 'Svizzera'">
          <CuSelect
            label="Cantone"
            v-model="form.region"
            :options="cantoneOptions"
            placeholder="Seleziona"
            :danger="showValidation && !validators.required(form.region)"
            @change="form.province = ''; form.comune = ''"
          />
          <CuSelect
            label="Distretto"
            v-model="form.province"
            :options="distrettoOptions"
            placeholder="Seleziona"
            :danger="showValidation && !validators.required(form.province)"
            @change="form.comune = ''"
          />
          <CuSelect
            label="Comune"
            v-model="form.comune"
            :options="comuneChOptions"
            placeholder="Seleziona"
            :danger="showValidation && !validators.required(form.comune)"
          />
        </template>
      </form>
    </div>
    </CuWizard>
    </div>
    <ProfileSavedSheet
      :show="showProfileSavedSheet"
      @close="showProfileSavedSheet = false"
      @continue="handleProfileSavedContinue"
    />
  <!-- Loading Spinner Overlay -->
  <div v-if="isLoading" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
    <i class="bx bx-loader-alt text-6xl text-primary animate-spin"></i>
  </div>
</div>
</template>

<script>
import CuWizard from '../components/Wizard.vue'
import WizardSteps from '../components/WizardSteps.vue'
import CuInput from '../components/cu/CuInput.vue'
import CuPhoneInput from '../components/cu/CuPhoneInput.vue'
import CuSelect from '../components/cu/CuSelect.vue'
import CuRadioGroup from '../components/cu/CuRadioGroup.vue'
import ProfileSavedSheet from '../components/dialog-sheets/ProfileSavedSheet.vue'
import EtaScenicaSheet from '../components/dialog-sheets/EtaScenicaSheet.vue'
import ExitConfirmationSheet from '../components/dialog-sheets/ExitConfirmationSheet.vue'
import appClient from '../api/appClient.js'
import eventBus from '../utils/eventBus'
import { jwtDecode } from "jwt-decode";

export default {
  name: "ProfileWizard",
  components: { CuWizard, WizardSteps, CuInput, CuPhoneInput, CuSelect, CuRadioGroup, ProfileSavedSheet, EtaScenicaSheet, ExitConfirmationSheet },
  data() {
    return {
      step: 1,
      totalSteps: 4,
      showPassword: false,
      showValidation: false,
      showProfileSavedSheet: false,
      showDatePicker: false,
      tempBirthdate: null,
      showParentDatePicker: false,
      tempParentBirthdate: null,
      form: {
        name: '',
        surname: '',
        codice_fiscale: '',
        birthdate: '',
        isoBirthdate: '',
        phone: '',
        email: '',
        password: '',
        height: '',
        weight: '',
        size: '',
        shoeSize: '',
        eta: '',
        eta_scenica: [],
        ethnicity: '',
        bodyType: '',
        eyes: '',
        gender: '',
        hairColor: '',
        hairType: '',
        hairCut: '',
        hairColoring: '',
        profession: [],
        country: 'Italia',
        region: '',
        province: '',
        comune: '',
        avatar: '',
        extension: '',
        acceptTos: false,
        nationality: 'Italia',
        nome_genitore: '',
        cognome_genitore: '',
        codice_fiscale_genitore: '',
        phone_genitore: '',
        documento_genitore: '',
        data_nascita_genitore: '',
      },
      showEtaScenicaSheet: false,
      showExitConfirmationSheet: false,
      phonePrefilled: false,
      datePickerStyle: {},
      parentDatePickerStyle: {},
      countryOptions: [
        { value: 'Italia', label: 'Italia' },
        { value: 'Svizzera', label: 'Svizzera' },

      ],
      nationalityOptions: [
        { value: 'Italia', label: 'Italiana' },
        { value: 'Svizzera', label: 'Svizzera' },
      ],
      configData: null,
      isLoading: false // Loading state for API requests
    }
  },
  computed: {
    // Check if user is under 18 years old
    isUnder18() {
      // if date is not set or not valid, return false;
      if(!this.validators.birthdate(this.form.birthdate)){
        return false;
      }
      return this.form.eta !== null && Number(this.form.eta) < 18;
    },
    // ...existing computed...
    etaScenicaDisplay() {
      if (Array.isArray(this.form.eta_scenica) && this.form.eta_scenica.length === 2) {
        return this.form.eta_scenica[0] + ' - ' + this.form.eta_scenica[1];
      }
      return '';
    },
    validators() {
      return {
        name: val => typeof val === 'string' && val.trim().length >= 2,
        surname: val => typeof val === 'string' && val.trim().length >= 2,
        codiceFiscale: this.validateCodiceFiscale,
        birthdate: val => /^\d{2}\/\d{2}\/\d{4}$/.test(val),
        phone: val => typeof val === 'string' && /^\+?\d{8,16}$/.test(val.replace(/\s/g, '')),
        email: val => typeof val === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
        password: val => {
  if (typeof val !== 'string') return false;
  // At least 8 characters
  if (val.length < 8) return false;
  // At least one number
  if (!/[0-9]/.test(val)) return false;
  // At least one special character
  if (!/[!@#$£%^&*(),.?":{}|<>]/.test(val)) return false;
  // No spaces
  if (val.includes(' ')) return false;
  return true;
},
        height: val => !!val && !isNaN(val) && Number(val) > 100 && Number(val) < 250,
        weight: val => !!val && !isNaN(val) && Number(val) > 30 && Number(val) < 250,
        shoeSize: val => !!val && !isNaN(val) && Number(val) > 20 && Number(val) < 55,
        eta: val => {
          if (!val || isNaN(val)) return false;
          const min = this.configData?.data?.range_eta?.min ?? 0;
          const max = this.configData?.data?.range_eta?.max ?? 120;
          return Number(val) >= min && Number(val) <= max;
        },
        eta_scenica: val => {
          if (!Array.isArray(val) || val.length !== 2) return false;
          const min = this.configData?.data?.range_eta_scenica?.min ?? 0;
          const max = this.configData?.data?.range_eta_scenica?.max ?? 120;
          return val[0] >= min && val[1] <= max && val[0] <= val[1];
        },
        required: val => val !== undefined && val !== null && val !== '',
        // Parent field validators
        parentRequired: val => {
          if (!this.isUnder18) return true; // Not required if over 18
          return val !== undefined && val !== null && val !== '';
        },
        parentCodiceFiscale: val => {
          if (!this.isUnder18) return true; // Not required if over 18
          if (this.form.nationality === 'Italia') {
            return /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/.test(val.toUpperCase());
          } else if (this.form.nationality === 'Svizzera') {
            return /^\d{3}\.\d{3}\.\d{3}\.\d{3}$/.test(val);
          }
          return false;
        },
        parentPhone: val => {
          if (!this.isUnder18) return true; // Not required if over 18
          return typeof val === 'string' && /^\+?\d{8,16}$/.test(val.replace(/\s/g, ''));
        },
        parentBirthdate: val => {
          if (!this.isUnder18) return true; // Not required if over 18
          if (!/^\d{2}\/\d{2}\/\d{4}$/.test(val)) return false;
          
          // Parse the date and calculate age
          const parts = val.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1; // JS months are 0-based
            const year = parseInt(parts[2], 10);
            const birthDateObj = new Date(year, month, day);
            if (!isNaN(birthDateObj)) {
              const age = this.calculateAge(birthDateObj);
              return age >= 18; // Parent must be at least 18 years old
            }
          }
          return false;
        }
      }
    },
    // Dynamic region/province/comune/cantone/distretto/comune_ch options
    regionOptions() {
      if (
        this.form.country === "Italia" &&
        this.configData &&
        this.configData.status &&
        this.configData.data &&
        Array.isArray(this.configData.data.regioni)
      ) {
        return this.configData.data.regioni.map(r => ({
          value: r.id,
          label: r.nome
        }));
      }
      return [];
    },
    provinceOptions() {
      if (
        this.form.country === "Italia" &&
        this.configData &&
        this.configData.status &&
        this.configData.data &&
        Array.isArray(this.configData.data.province) &&
        this.form.region
      ) {
        return this.configData.data.province
          .filter(p => String(p.id_regione) === String(this.form.region))
          .map(p => ({
            value: p.id,
            label: p.nome
          }));
      }
      return [];
    },
    comuneOptions() {
      if (
        this.form.country === "Italia" &&
        this.configData &&
        this.configData.status &&
        this.configData.data &&
        Array.isArray(this.configData.data.comuni) &&
        this.form.province
      ) {
        return this.configData.data.comuni
          .filter(c => String(c.id_provincia) === String(this.form.province))
          .map(c => ({
            value: c.id,
            label: c.nome
          }));
      }
      return [];
    },
    cantoneOptions() {
      if (
        this.form.country === "Svizzera" &&
        this.configData &&
        this.configData.status &&
        this.configData.data &&
        Array.isArray(this.configData.data.cantoni)
      ) {
        return this.configData.data.cantoni.map(c => ({
          value: c.id,
          label: c.nome
        }));
      }
      return [];
    },
    distrettoOptions() {
      if (
        this.form.country === "Svizzera" &&
        this.configData &&
        this.configData.status &&
        this.configData.data &&
        Array.isArray(this.configData.data.distretti) &&
        this.form.region
      ) {
        return this.configData.data.distretti
          .filter(d => String(d.id_cantone) === String(this.form.region))
          .map(d => ({
            value: d.id,
            label: d.nome
          }));
      }
      return [];
    },
    comuneChOptions() {
      if (
        this.form.country === "Svizzera" &&
        this.configData &&
        this.configData.status &&
        this.configData.data &&
        Array.isArray(this.configData.data.comuni_ch) &&
        this.form.province
      ) {
        return this.configData.data.comuni_ch
          .filter(c => String(c.id_distretto) === String(this.form.province))
          .map(c => ({
            value: c.id,
            label: c.nome
          }));
      }
      return [];
    },
    // Dynamic dropdowns from filtri
    genderOptions() {
      return this.getFiltriOptions("sesso");
    },
    ethnicityOptions() {
      return this.getFiltriOptions("etnia");
    },
    bodyTypeOptions() {
      return this.getFiltriOptions("corporatura");
    },
    sizeOptions() {
      return this.getFiltriOptions("taglia");
    },
    hairColorOptions() {
      return this.getFiltriOptions("colore_capelli");
    },
    hairTypeOptions() {
      return this.getFiltriOptions("tipologia_capelli");
    },
    eyesOptions() {
      return this.getFiltriOptions("colore_occhi");
    },
    hairCutOptions() {
      return this.getFiltriOptions("disponibile_taglio");
    },
    hairColoringOptions() {
      return this.getFiltriOptions("disponibile_colore");
    },
    professionOptions() {
      return this.getFiltriOptions("categoria_parte", false);
    },
    getFiltriOptions() {
      return (chiave, valueInsteadOfId) => {
        if (
          this.configData &&
          this.configData.status &&
          this.configData.data &&
          Array.isArray(this.configData.data.filtri)
        ) {
          const filtro = this.configData.data.filtri.find(f => f.chiave === chiave);
          if (filtro && Array.isArray(filtro.opzioni)) {
            return filtro.opzioni.map(opt => ({
              value: valueInsteadOfId ? opt.valore : opt.id,
              label: opt.valore
            }));
          }
        }
        return [];
      };
    },
    buttons() {
      // All steps except last: black button, "Prosegui"
      // Last step: primary button, "Salva profilo e prosegui"
      let disabled = false
      if (this.step === 1) {
        disabled =
          !this.form.name || !this.form.name.trim() ||
          !this.form.birthdate || !this.form.birthdate.trim() ||
          typeof this.form.phone !== 'string' || !this.form.phone.trim() ||
          !this.form.email || !this.form.email.trim() ||
          !this.form.password ||
          !this.form.acceptTos
          
        // Additional validation for under 18 users
        if (this.isUnder18) {
          disabled = disabled ||
            !this.form.nome_genitore || !this.form.nome_genitore.trim() ||
            !this.form.cognome_genitore || !this.form.cognome_genitore.trim() ||
            !this.form.codice_fiscale_genitore || !this.form.codice_fiscale_genitore.trim() ||
            !this.form.phone_genitore || !this.form.phone_genitore.trim() ||
            !this.form.documento_genitore || !this.form.documento_genitore.trim() ||
            !this.form.data_nascita_genitore || !this.form.data_nascita_genitore.trim()
        }
      } else if (this.step === 2) {
        disabled =
          !this.form.height ||
          !this.form.weight ||
          !this.form.size ||
          !this.form.shoeSize ||
          !this.form.eta ||
          !this.form.eta_scenica ||
          !this.form.ethnicity ||
          !this.form.bodyType ||
          !this.form.eyes ||
          !this.form.gender
      } else if (this.step === 3) {
        disabled =
          !this.form.hairColor ||
          !this.form.hairType ||
          !this.form.hairCut ||
          !this.form.hairColoring
      }
      if (this.step < this.totalSteps) {
        return [
          {
            text: "Prosegui",
            primary: true,
            secondary: false,
            dark: false,
            disabled,
            onClick: this.nextStep
          }
        ]
      } else if (this.step === this.totalSteps) {
        // Last step
        const disabled =
          !this.form.profession ||
          !this.form.country ||
          !this.form.region ||
          !this.form.province ||
          !this.form.acceptTos
        return [
          {
            text: "Salva profilo e prosegui",
            primary: true,
            secondary: false,
            dark: false,
            disabled,
            onClick: this.saveProfile
          }
        ]
      }
      return []
    }
  },
  mounted() {
    // Check if user is already logged in with a valid profile
    this.checkExistingProfile();

    // Restore form from localStorage (except phone)
    const savedForm = localStorage.getItem('profileWizardForm');
    if (savedForm) {
      try {
        const parsed = JSON.parse(savedForm);
        Object.keys(parsed).forEach(key => {
          if (key !== 'phone') {
            this.form[key] = parsed[key];
          }
        });
      } catch (e) {
        // ignore parse errors
      }
    }

    // If birthdate is present, calculate and set age
    if (this.form.birthdate) {
      // Try to parse the birthdate string (gg/mm/aaaa)
      const parts = this.form.birthdate.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // JS months are 0-based
        const year = parseInt(parts[2], 10);
        const birthDateObj = new Date(year, month, day);
        if (!isNaN(birthDateObj)) {
          this.form.eta = this.calculateAge(birthDateObj);
        }
      }
    }

    // Pre-fill phone from phone_token if present
    const phoneToken = this.$route.query && this.$route.query.phone_token;
    if (phoneToken) {
      try {
        const payload = jwtDecode(phoneToken);
        // Check if token is expired
        if (payload && payload.exp && typeof payload.exp === 'number') {
          const now = Math.floor(Date.now() / 1000);
          if (payload.exp < now) {
            this.$router.push('/');
            return;
          }
        }
        if (payload && payload.phone) {
          this.form.phone = payload.phone;
          this.phonePrefilled = true;
        }
      } catch (e) {
        console.error('Error decoding phone_token:', e);
        // ignore decoding errors
      }
    }
    // Fetch /config for possible field values
    this.isLoading = true;
    appClient
      .post('/config')
      .then(res => {
        this.configData = res.data
      })
      .catch(() => {
        this.configData = null
      })
      .finally(() => {
        this.isLoading = false;
      });

    // Add event listeners for date picker positioning
    document.addEventListener('click', this.handleDatePickerClickOutside);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll, true);
  },

  beforeDestroy() {
    // Clean up event listeners
    document.removeEventListener('click', this.handleDatePickerClickOutside);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll, true);
  },

  watch: {
    tempBirthdate(n){
      // n is date type, format it to DD/MM/YYYY
      if (n) {
        this.form.isoBirthdate = n.toISOString().split('T')[0]; // YYYY-MM-DD format
        this.form.birthdate = n.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '/')
        // Calculate and set age
        this.form.eta = this.calculateAge(n);
        this.showDatePicker = false
      } else {
        this.form.birthdate = ''  
        this.form.isoBirthdate = ''
        this.form.eta = ''
      }
    },

    tempParentBirthdate(n){
      // n is date type, format it to DD/MM/YYYY
      if (n) {
        this.form.data_nascita_genitore = n.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '/')
        this.showParentDatePicker = false
      } else {
        this.form.data_nascita_genitore = ''  
      }
    },

    showDatePicker(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.updateDatePickerPosition();
        });
      }
    },
    
    showParentDatePicker(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.updateParentDatePickerPosition();
        });
      }
    },

     form: {
      handler(newForm) {
        // Save all form fields except phone and avatar to localStorage
        // eslint-disable-next-line no-unused-vars
        const { phone, avatar, extension, ...toSave } = newForm;
        try {
          localStorage.setItem('profileWizardForm', JSON.stringify(toSave));
        } catch (e) {
          console.warn('Failed to save form to localStorage:', e);
          // Optionally clear localStorage if it's full
          // localStorage.removeItem('profileWizardForm');
        }
      },
      deep: true
    },
    'form.country'(){
      this.form.region = '';
      this.form.province = '';
      this.form.comune = '';
    }
  },

  methods: {
    async checkExistingProfile() {
      try {
        const token = localStorage.getItem('castingup_app_token');
        if (token) {
          const res = await appClient.post('/profile', {});
          if (res.data && res.data.status && res.data.data && res.data.data.id) {
            // User is already logged in with a valid profile, redirect to overview
            this.$router.push('/overview');
            return;
          }
        }
      } catch (e) {
        // If profile check fails, continue with wizard (user needs to complete profile)
      }
    },
    
    updateDatePickerPosition() {
      this.$nextTick(() => {
        const input = document.querySelector('input[placeholder="gg/mm/aaaa"]:not([placeholder*="Genitore"])');
        if (!input || !this.$refs.datePickerContainer) return;
        
        const rect = input.getBoundingClientRect();
        const pickerHeight = 250; // approximate height of the date picker
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;
        
        // Position picker below by default, above if not enough space
        const showAbove = spaceBelow < pickerHeight && spaceAbove > spaceBelow;
        
        this.datePickerStyle = {
          left: `${rect.left}px`,
          width: `${rect.width}px`,
          top: showAbove ? `${rect.top - pickerHeight}px` : `${rect.bottom + 8}px`
        };
      });
    },
    
    updateParentDatePickerPosition() {
      this.$nextTick(() => {
        const input = document.querySelector('input[placeholder="gg/mm/aaaa"][placeholder*="Genitore"], input[label*="Genitore"][placeholder="gg/mm/aaaa"]');
        if (!input || !this.$refs.parentDatePickerContainer) return;
        
        const rect = input.getBoundingClientRect();
        const pickerHeight = 250; // approximate height of the date picker
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;
        
        // Position picker below by default, above if not enough space
        const showAbove = spaceBelow < pickerHeight && spaceAbove > spaceBelow;
        
        this.parentDatePickerStyle = {
          left: `${rect.left}px`,
          width: `${rect.width}px`,
          top: showAbove ? `${rect.top - pickerHeight}px` : `${rect.bottom + 8}px`
        };
      });
    },
    
    openDatePicker() {
      this.showDatePicker = true;
      this.updateDatePickerPosition();
    },
    
    openParentDatePicker() {
      this.showParentDatePicker = true;
      this.updateParentDatePickerPosition();
    },
    
    handleDatePickerClickOutside(e) {
      if (this.showDatePicker && this.$refs.datePickerContainer && !this.$refs.datePickerContainer.contains(e.target)) {
        // Check if click was on the input or calendar icon
        const input = document.querySelector('input[placeholder="gg/mm/aaaa"]:not([placeholder*="Genitore"])');
        const calendarIcon = input?.parentElement?.querySelector('.bx-calendar');
        if (!input?.contains(e.target) && !calendarIcon?.contains(e.target)) {
          this.showDatePicker = false;
        }
      }
      
      if (this.showParentDatePicker && this.$refs.parentDatePickerContainer && !this.$refs.parentDatePickerContainer.contains(e.target)) {
        // Check if click was on the parent input or calendar icon
        const parentInput = document.querySelector('input[label*="Genitore"][placeholder="gg/mm/aaaa"]') || 
                            Array.from(document.querySelectorAll('input[placeholder="gg/mm/aaaa"]'))
                              .find(el => el.closest('form')?.textContent?.includes('ANAGRAFICA GENITORE'));
        const parentCalendarIcon = parentInput?.parentElement?.querySelector('.bx-calendar');
        if (!parentInput?.contains(e.target) && !parentCalendarIcon?.contains(e.target)) {
          this.showParentDatePicker = false;
        }
      }
    },
    
    handleResize() {
      if (this.showDatePicker) {
        this.updateDatePickerPosition();
      }
      if (this.showParentDatePicker) {
        this.updateParentDatePickerPosition();
      }
    },
    
    handleScroll() {
      if (this.showDatePicker) {
        this.updateDatePickerPosition();
      }
      if (this.showParentDatePicker) {
        this.updateParentDatePickerPosition();
      }
    },
    handleEtaScenicaConfirm(range) {
      this.form.eta_scenica = range;
      this.showEtaScenicaSheet = false;
    },
    
    handleExitConfirm() {
      this.showExitConfirmationSheet = false;
      this.$router.back();
    },
    // Calculate age from a Date object
    calculateAge(dateObj) {
      if (!(dateObj instanceof Date) || isNaN(dateObj)) return '';
      const today = new Date();
      let age = today.getFullYear() - dateObj.getFullYear();
      const m = today.getMonth() - dateObj.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < dateObj.getDate())) {
        age--;
      }
      return age;
    },

    triggerAvatarInput() {
      this.$refs.avatarInput.click();
    },
    validateCodiceFiscale(codice) {
      // if italian codice fiscale, validate format, otherwise if swiss AVS, validate format
      if (this.form.nationality === 'Italia') {
        return /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/.test(codice.toUpperCase());
      } else if (this.form.nationality === 'Svizzera') {
        return /^\d{3}\.\d{3}\.\d{3}\.\d{3}$/.test(codice);
      }
      return false;
    },

    nextStep() {
      this.showValidation = true
      if (this.step === 1) {
        let validationFailed = false;
        
        // Basic validation
        if (
          !this.validators.name(this.form.name) ||
          !this.validators.surname(this.form.surname) ||
          !this.validators.codiceFiscale(this.form.codice_fiscale) ||
          !this.validators.birthdate(this.form.birthdate) ||
          !this.validators.phone(this.form.phone) ||
          !this.validators.email(this.form.email) ||
          !this.validators.password(this.form.password) ||
          !this.form.acceptTos
        ) {
          validationFailed = true;
        }
        
        // Additional validation for under 18 users (parent information)
        if (this.isUnder18) {
          if (
            !this.validators.parentRequired(this.form.nome_genitore) ||
            !this.validators.parentRequired(this.form.cognome_genitore) ||
            !this.validators.parentCodiceFiscale(this.form.codice_fiscale_genitore) ||
            !this.validators.parentPhone(this.form.phone_genitore) ||
            !this.validators.parentRequired(this.form.documento_genitore) ||
            !this.validators.parentBirthdate(this.form.data_nascita_genitore)
          ) {
            validationFailed = true;
          }
        }
        
        if (validationFailed) {
          return;
        }
      }
      if (this.step === 2) {
        if (
          !this.validators.height(this.form.height) ||
          !this.validators.weight(this.form.weight) ||
          !this.validators.shoeSize(this.form.shoeSize) ||
          !this.validators.eta(this.form.eta) ||
          !this.validators.eta_scenica(this.form.eta_scenica) ||
          !this.validators.required(this.form.size) ||
          !this.validators.required(this.form.ethnicity) ||
          !this.validators.required(this.form.bodyType) ||
          !this.validators.required(this.form.eyes) ||
          !this.validators.required(this.form.gender)
        ) {
          return
        }
      }
      if (this.step === 3) {
        if (
          !this.validators.required(this.form.hairColor) ||
          !this.validators.required(this.form.hairType) ||
          !this.validators.required(this.form.hairCut) ||
          !this.validators.required(this.form.hairColoring)
        ) {
          return
        }
      }
      if (this.step < this.totalSteps) {
        // Scroll to top when going to next step
        document.querySelector('#app').scrollTo({ top: 0, behavior: 'smooth' })
        setTimeout(() => {
          this.step++
          this.showValidation = false
        }, 300) // Hide validation after 300ms to allow scroll animation
        
        
      }
      this.showDatePicker = false
    },
    async saveProfile() {
      this.showValidation = true
      if (
        !this.form.avatar ||
        !(Array.isArray(this.form.profession) && this.form.profession.length > 0) ||
        !this.validators.required(this.form.country) ||
        !this.validators.required(this.form.region) ||
        !this.validators.required(this.form.province) ||
        !this.form.acceptTos
      ) {
        return
      }

      this.isLoading = true;
      try {
        // Hash password with SHA256 before sending
        const hashPassword = async (password) => {
          const encoder = new TextEncoder();
          const data = encoder.encode(password);
          const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        };
        const hashedPassword = await hashPassword(this.form.password);

        // Prepare request body for /iscrizione/conferma
        const body = {
          nome: this.form.name,
          cognome: this.form.surname,
          email: this.form.email,
          password: hashedPassword,
          codice_fiscale: this.form.codice_fiscale,
          data_nascita: this.form.isoBirthdate, // Should be in YYYY-MM-DD format
          avatar: this.form.avatar ? this.form.avatar.split(',')[1] : undefined,
          extension: this.form.extension || undefined,
          citta_di_nascita: this.form.comune || undefined,
          birth_state: this.form.nationality == 'Italia' ? 'italy' : 'swiss',
          phone: this.form.phone,
          nationality: this.form.nationality || undefined,
          // get profession option value from ids
          professione_abituale: this.form.profession.map(p => {
            const option = this.professionOptions.find(opt => opt.value === p);
            return option ? option.label : null;
          }).join(', ') || undefined,
          nome_genitore: this.form.nome_genitore || undefined,
          cognome_genitore: this.form.cognome_genitore || undefined,
          codice_fiscale_genitore: this.form.codice_fiscale_genitore || undefined,
          phone_genitore: this.form.phone_genitore || undefined,
          documento_genitore: this.form.documento_genitore || undefined,
          data_nascita_genitore: this.form.data_nascita_genitore || undefined,
          current_nation: this.form.country
        };

        
        // Add phone_token if present in query
        const phoneToken = this.$route.query && this.$route.query.phone_token;
        if (phoneToken) {
          body.phone_token = phoneToken;
        }

        const res = await appClient.post('/iscrizione/conferma', body);
        if (res.data && res.data.status) {
          //localStorage.removeItem('profileWizardForm'); // Clear saved form data
          // After signup, login with phone_token and select first profile
          if (phoneToken) {
            try {
              // 2. Get profiles
              const profilesRes = await appClient.post('/phone/profiles', { phone_token: phoneToken });
              let profileId = null;
              if (
                profilesRes.data &&
                Array.isArray(profilesRes.data.profiles) &&
                profilesRes.data.profiles.length > 0
              ) {
                profileId = profilesRes.data.profiles[0].id;
              }
              // 3. If profileId, login again with profile_id
              let finalToken = null;
              if (profileId) {
                const loginWithProfileRes = await appClient.post('/login', { phone_token: phoneToken, profile_id: profileId });
                if (loginWithProfileRes.data && loginWithProfileRes.data.status && loginWithProfileRes.data.data) {
                  finalToken = loginWithProfileRes.data.data.token;
                }
              } 
              // 4. Store token in localStorage
              if (finalToken) {
                localStorage.setItem('castingup_app_token', finalToken);
                // Optionally, fetch user profile for consistency
                try {
                  await appClient.post('/profile', {});
                } catch (e) {
                  // ignore
                }
                // Call updateProfile and updateProfileFiltri after login
                try {
                  await this.updateProfile();
                } catch (e) {
                  // ignore
                }
                try {
                  await this.updateProfileFiltri();
                } catch (e) {
                  // ignore
                }
                // Refresh user data in App.vue after successful login
                eventBus.emit('userRefresh')
              }
            } catch (e) {
              console.error('Error during login with phone_token:', e);
              // ignore login errors, user will not be logged in
            }
          }
          this.showProfileSavedSheet = true;
        } else {
          window.$toast({
            type: "error",
            title: "Errore",
            message: res.data && res.data.data ? res.data.data.error_description : "Errore durante la conferma dell'iscrizione"
          });
        }
      } catch (e) {
        window.$toast({
          type: "error",
          title: "Errore",
          message: "Errore di rete durante la conferma dell'iscrizione"
        });
      } finally {
        this.isLoading = false;
      }
    },
    handleProfileSavedContinue() {
      this.showProfileSavedSheet = false;
      // Determine if desktop or mobile
      const returnTo = this.$route.query.returnTo || '/casting/1';
      // Extract casting id from returnTo (expects format /casting/{id})
      let castingId = null;
      const match = returnTo.match(/^\/casting\/(\d+)/);
      if (match) {
        castingId = match[1];
      }

      // scroll to top
      document.querySelector('#app').scrollTo({ top: 0, behavior: 'smooth' });
      

      setTimeout(() => {
        // Instead of going directly to casting, go to Profile in post-signup mode
        this.$router.push({ 
          path: '/profile-view', 
          query: { 
            postSignup: 'true',
            returnTo: returnTo,
            castingId: castingId 
          } 
        });
      }, 300); // Delay to allow scroll animation
      
    },
    
    handleAvatarChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (event) => {
        this.form.avatar = event.target.result;
        // Get extension from file type or name
        const ext = file.type
          ? '.' + file.type.split('/').pop()
          : (file.name ? '.' + file.name.split('.').pop() : '');
        this.form.extension = ext;
      };
      reader.readAsDataURL(file);
    },
    handleBack() {
      if (this.step > 1) {
        this.step--;
        this.showValidation = false;
        this.showDatePicker = false;
        this.showParentDatePicker = false;
        // Scroll to top when going to previous step
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } else {
        // At step 1, show confirmation before exiting
        this.showExitConfirmationSheet = true;
      }
    },

    async updateProfile() {
      // Build address body based on country
      let body = {};
      if (this.form.country === 'Italia') {
        body = {
          regione_residenza: this.form.region,
          provincia_residenza: this.form.province,
          citta_residenza: this.form.comune
        };
      } else if (this.form.country === 'Svizzera') {
        body = {
          cantone_residenza_ch: this.form.region,
          distretto_residenza_ch: this.form.province,
          citta_residenza_ch: this.form.comune
        };
      }
      try {
        await appClient.post('/profile/update', body);
        // Optionally, show a success message or handle response
      } catch (e) {
        // Optionally, handle error
      }
    },

    async updateProfileFiltri() {
      // Build payload for /profile/filtri
      const payload = {
        sesso: this.form.gender,
        eta: this.form.eta, // You may need to calculate or add this field to the form
        eta_scenica: Array.isArray(this.form.eta_scenica) && this.form.eta_scenica.length === 2
          ? `${this.form.eta_scenica[0]}:${this.form.eta_scenica[1]}`
          : '',
        etnia: this.form.ethnicity,
        altezza: this.form.height,
        peso: this.form.weight,
        taglia: this.form.size,
        corporatura: this.form.bodyType,
        numero_scarpa: this.form.shoeSize,
        colore_capelli: this.form.hairColor,
        tipologia_capelli: this.form.hairType,
        disponibile_taglio: this.form.hairCut,
        disponibile_colore: this.form.hairColoring,
        colore_occhi: this.form.eyes,
        categoria_parte: Array.isArray(this.form.profession) ? this.form.profession.join(', ') : '',
      };
      console.log('Profile filtri payload:', payload);
      // it only accept strings.. because of previous web agency
      for (const key in payload) {
        if (typeof payload[key] === 'number') {
          payload[key] = String(payload[key]);
        }
      }
      try {
        await appClient.post('/profile/filtri/4/update', payload);
        // Optionally, show a success message or handle response
      } catch (e) {
        // Optionally, handle error
      }
    }
  }
}
</script>
